import React from "react";
import Logo from "@/components/Logo";

// CSS-only reveal overlay. Uses compositor-driven animation so it can never
// block the main thread or get stuck. Skipped after first view in a session.
export default function Loader() {
  const seen = typeof window !== "undefined" && sessionStorage.getItem("intersect_loaded") === "1";
  if (typeof window !== "undefined") sessionStorage.setItem("intersect_loaded", "1");
  if (seen) return null;

  return (
    <div data-testid="page-loader" className="intersect-loader" aria-hidden>
      <div className="intersect-loader-inner">
        <Logo width={220} />
        <div className="intersect-loader-line" />
      </div>
      <style>{`
        .intersect-loader{position:fixed;inset:0;z-index:100;background:#0C0C0D;display:flex;align-items:center;justify-content:center;animation:il-fade 2.4s cubic-bezier(0.16,1,0.3,1) forwards;}
        .intersect-loader-inner{display:flex;flex-direction:column;align-items:center;animation:il-up 1s cubic-bezier(0.16,1,0.3,1) both;}
        .intersect-loader-line{margin-top:2rem;height:1px;background:rgba(198,161,91,0.6);width:0;animation:il-line 1.4s cubic-bezier(0.16,1,0.3,1) 0.3s forwards;}
        @keyframes il-fade{0%{opacity:1;visibility:visible}70%{opacity:1;visibility:visible}100%{opacity:0;visibility:hidden;pointer-events:none}}
        @keyframes il-up{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
        @keyframes il-line{from{width:0}to{width:120px}}
        @media (prefers-reduced-motion: reduce){.intersect-loader{animation:il-fade-fast 0.6s linear forwards}.intersect-loader-inner,.intersect-loader-line{animation:none}.intersect-loader-line{width:120px}}
        @keyframes il-fade-fast{to{opacity:0;visibility:hidden;pointer-events:none}}
      `}</style>
    </div>
  );
}
